<template>
  <div class="p-4">
    <div class="row py-2">
      <div style="width: 5% !important"></div>
      <div class="col-md-5">
        <p class="text-muted mb-0">The number of visitors on this page:</p>
      </div>
      <div class="col-md-5">
        <p class="text-muted mb-0">The number of overall conversions was:</p>
      </div>
      <div class="text-center" style="width: 10% !important">
        <p class="text-muted mb-0">Conversion rate</p>
      </div>
    </div>
    <div class="row py-2">
      <div class="text-right" style="width: 5% !important">
        <p class="h2">A</p>
      </div>
      <div class="col-md-5">
        <input
          type="text"
          class="form-control d-block mx-auto"
          v-model="a_visitor"
          @keyup="calculate()"
        />
      </div>
      <div class="col-md-5">
        <input
          type="text"
          class="form-control d-block mx-auto"
          v-model="a_converted"
          @keyup="calculate()"
        />
      </div>
      <div class="text-center" style="width: 10% !important">
        <p class="h2">{{ a_conversion }}%</p>
      </div>
    </div>
    <div class="row py-2">
      <div class="text-right" style="width: 5% !important">
        <p class="h2">B</p>
      </div>
      <div class="col-md-5">
        <input
          type="text"
          class="form-control d-block mx-auto"
          v-model="b_visitor"
          @keyup="calculate()"
        />
      </div>
      <div class="col-md-5">
        <input
          type="text"
          class="form-control d-block mx-auto"
          v-model="b_converted"
          @keyup="calculate()"
        />
      </div>
      <div class="text-center" style="width: 10% !important">
        <p class="h2">{{ b_conversion }}%</p>
      </div>
    </div>

    <div class="row py-2 mx-4 mt-4">
      <div class="col-md-12 p-5">
        <p class="h1 fw-700 mb-4" style="color: #101d3b !important">
          Your test result
        </p>

        <p class="fs-20" style="color: #101d3b !important">
          {{
            Number(b_conversion) > Number(a_conversion)
              ? 'Test "B" converted ' +
                ((Number(b_conversion) / Number(a_conversion)) * 100).toFixed(
                  0
                ) +
                '% better than Test "A"'
              : 'Test "A" converted ' +
                ((Number(a_conversion) / Number(b_conversion)) * 100).toFixed(
                  0
                ) +
                '% better than Test "B"'
          }}
          . I am
          <b>{{ (confident * 100).toFixed(0) }}%</b> certain that this result
          will improve your conversion rate.
        </p>
        <p class="fs-20" style="color: #101d3b !important" v-if="significant">
          Your A/B test is
          <u class="font-weight-bold text-success">statistically significant</u
          >!
        </p>
        <p class="fs-20" style="color: #101d3b !important" v-else>
          Your A/B test is
          <u class="font-weight-bold text-danger"
            >NOT statistically significant</u
          >.
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data: function () {
    return {
      a_visitor: 1000,
      a_converted: 80,
      a_conversion: 0,
      b_visitor: 1000,
      b_converted: 120,
      b_conversion: 0,
      significant: false,
      confident: 0,
    }
  },
  mounted() {
    this.calculate()
  },
  methods: {
    calculate() {
      this.a_conversion =
        this.a_converted !== 0 && this.a_visitor !== 0
          ? ((this.a_converted / this.a_visitor) * 100).toFixed(0)
          : 0
      this.b_conversion =
        this.b_converted !== 0 && this.b_visitor !== 0
          ? ((this.b_converted / this.b_visitor) * 100).toFixed(0)
          : 0
      this.calculateStatisticSignificance(
        {
          visitor: this.a_visitor,
          convert: this.a_converted,
        },
        {
          visitor: this.b_visitor,
          convert: this.b_converted,
        }
      )
    },
    calculateStatisticSignificance(control, variant) {
      function getCR(t) {
        return t[1] / t[0]
      }

      function getZScore(c, t) {
        let z = getCR(t) - getCR(c)
        let s =
          (getCR(t) * (1 - getCR(t))) / t[0] +
          (getCR(c) * (1 - getCR(c))) / c[0]
        return z / Math.sqrt(s)
      }

      function cumnormdist(x) {
        let b1 = 0.31938153
        let b2 = -0.356563782
        let b3 = 1.781477937
        let b4 = -1.821255978
        let b5 = 1.330274429
        let p = 0.2316419
        let c = 0.39894228

        if (x >= 0.0) {
          let t = 1.0 / (1.0 + p * x)
          return (
            1.0 -
            c *
              Math.exp((-x * x) / 2.0) *
              t *
              (t * (t * (t * (t * b5 + b4) + b3) + b2) + b1)
          )
        } else {
          let t = 1.0 / (1.0 - p * x)
          return (
            c *
            Math.exp((-x * x) / 2.0) *
            t *
            (t * (t * (t * (t * b5 + b4) + b3) + b2) + b1)
          )
        }
      }

      let a = [control.visitor, control.convert]
      let b = [variant.visitor, variant.convert]
      let zValue = getZScore(a, b)
      let confident = cumnormdist(zValue)
      this.significant = confident >= 0.95 ? true : false
      this.confident = confident
      console.log(a, b, confident)
    },
    submit() {
      this.$http
        .get(
          process.env.API_ENDPOINT +
            `/headline/suggestion?headline=` +
            this.headline
        )
        .then((response) => {
          this.answer = response.data.result
        })
        .catch((err) => {
          console.error(err)
        })
    },
  },
}
</script>

<style scoped>
textarea {
  margin-bottom: 10px;
  font-size: 20px;
  width: 80%;
}

body {
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/FreeTools/ABSignificantCalculator.vue